var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "delete_outline_black_24dp",
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.249,
    height: 17.249,
    viewBox: "0 0 17.249 17.249",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_7183",
    "data-name": "Path 7183",
    d: "M0,0H17.249V17.249H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7263",
    "data-name": "Path 7263",
    d: "M5.719,14.5a1.442,1.442,0,0,0,1.437,1.437h5.75A1.442,1.442,0,0,0,14.343,14.5V7.312a1.442,1.442,0,0,0-1.437-1.437H7.156A1.442,1.442,0,0,0,5.719,7.312ZM7.875,7.312h4.312a.721.721,0,0,1,.719.719v5.75a.721.721,0,0,1-.719.719H7.875a.721.721,0,0,1-.719-.719V8.031A.721.721,0,0,1,7.875,7.312Zm4.672-3.594-.51-.51a.725.725,0,0,0-.5-.208h-3a.725.725,0,0,0-.5.208l-.51.51h-1.8a.719.719,0,0,0,0,1.437h8.624a.719.719,0,0,0,0-1.437Z",
    transform: "translate(-1.407 -0.844)",
    fill: "#6676aa"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/deleteIcon.ca6fd31296bee60deb9e49a55c947427.svg";
export { ForwardRef as ReactComponent };